import { FC, memo } from 'react'
import { Badge, BoxProps } from '@chakra-ui/react'
import { differenceInHours as _differenceInHours } from 'date-fns'
import { usePersonalization } from 'contexts/Personalization/Provider'

type Props = BoxProps & {
  date?: Date | string
  differenceInHours?: number
}

const NoveltyBadge: FC<Props> = ({ date, differenceInHours = 24 }) => {
  const { personalization } = usePersonalization()

  const isValidDate = (value: string | Date | undefined): boolean => {
    if (!value) return false
    const date = new Date(value)
    return !isNaN(date.getTime())
  }

  if (!isValidDate(date)) {
    return <></>
  }

  if (!date) return <></>

  if (_differenceInHours(new Date(Date.now()), new Date(date)) > differenceInHours) {
    return <></>
  }

  return (
    <Badge ml="1" variant="solid" colorScheme={personalization?.module_color || 'blue'}>
      Novo
    </Badge>
  )
}

export default memo(NoveltyBadge)
